// Этап 6, раздел 5 «Промокоды» (docs/PLAN.md) — строка таблицы в PromoCodesScreen.tsx. Единственное
// действие (деактивировать) не требует отдельного режима редактирования, как у PlanRow/
// SubscriptionCard, но своё busy/error на строку — тот же приём.
import { useState } from "react";

import { type AdminPromoCode, ApiError, deactivatePromoCode } from "../api/client";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU");
}

export function PromoCodeRow({
  promo,
  onChanged,
}: {
  promo: AdminPromoCode;
  onChanged: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function deactivate() {
    setBusy(true);
    setError(null);
    try {
      await deactivatePromoCode(promo.id);
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось деактивировать промокод");
    } finally {
      setBusy(false);
    }
  }

  return (
    <tr>
      <td>
        <code>{promo.code}</code>
      </td>
      <td>{promo.plan_titles.join(", ") || "—"}</td>
      <td>{promo.discount_value} дн.</td>
      <td>
        {formatDate(promo.valid_from)} — {formatDate(promo.valid_to)}
      </td>
      <td>
        {promo.is_used
          ? `погашен: ${promo.used_by_username ? `@${promo.used_by_username}` : promo.used_by_telegram_id}${
              promo.used_at ? `, ${formatDate(promo.used_at)}` : ""
            }`
          : promo.is_expired
            ? "истёк"
            : "активен"}
      </td>
      <td>
        <button className="secondary" disabled={busy || promo.is_expired} onClick={deactivate}>
          Деактивировать
        </button>
        {error && <div className="error-text" style={{ marginTop: 8, marginBottom: 0 }}>{error}</div>}
      </td>
    </tr>
  );
}
